/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef  } from 'react';
import './SingleSelect.css'; // Create a CSS file for styling
import { ChevronDown } from 'react-feather';

const SingleSelect = ({ options, selectedOption, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const singleDropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (singleDropdownRef.current && !singleDropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  return (
    <div className="single-select" ref={singleDropdownRef}>
      <div className="single-select__header" onClick={handleToggle}>
        {selectedOption || 'Select an option'}
        <ChevronDown />
      </div>
      {isOpen && (
        <div className="single-select__options">
          {options.map((option) => (
            <div
              key={option}
              className={`single-select__option ${selectedOption === option ? 'selected' : ''}`}
              onClick={() => handleSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SingleSelect;
